import "./FoodCategories.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function FoodCategories({ setActive }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="food-categories">
      <div className="title">
        <p>{t("categories")}</p>
      </div>
      <div className="rectangle-bg"></div>
      <div className="categories">
        {window.screen.width <= 767 ? (
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            className="swiper"
            spaceBetween={10}
            slidesPerView={1.25}
            centeredSlides={true}
            loop={false}
            direction="horizontal"
            observeParents={true}
            parallax={true}
            touchEventsTarget="container"
          >
            <SwiperSlide>
              <div
                className="food-category"
                onClick={() => {
                  navigate("/menu/category/26");
                  setActive(26);
                  localStorage.setItem("activeMenu", 26);
                }}
              >
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/fish.svg"
                  alt="Основни"
                />
                <p className="category-title">{t("Основни")}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="food-category"
                onClick={() => {
                  navigate("/menu/category/10");
                  setActive(10);
                  localStorage.setItem("activeMenu", 10);
                }}
              >
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/salads.svg"
                  alt="Салати"
                />
                <p className="category-title">{t("Салати")}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="food-category"
                onClick={() => {
                  navigate("/menu/category/24");
                  setActive(24);
                  localStorage.setItem("activeMenu", 24);
                }}
              >
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/starters.svg"
                  alt="Стартери"
                />
                <p className="category-title">{t("Стартери")}</p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div
                className="food-category"
                onClick={() => {
                  navigate("/menu/category/12");
                  setActive(12);
                  localStorage.setItem("activeMenu", 12);
                }}
              >
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/sushi.svg"
                  alt="Суши"
                />
                <p className="category-title">{t("Суши")}</p>
              </div>
            </SwiperSlide>
          </Swiper>
        ) : (
          <>
            <div
              className="food-category"
              onClick={() => {
                navigate("/menu/category/26");
                setActive(26);
                localStorage.setItem("activeMenu", 26);
              }}
            >
              <img
                src="https://alexfish-static.s3.eu-north-1.amazonaws.com/fish.svg"
                alt="Основни"
              />
              <p className="category-title">{t("Основни")}</p>
            </div>
            <div
              className="food-category"
              onClick={() => {
                navigate("/menu/category/10");
                setActive(10);
                localStorage.setItem("activeMenu", 10);
              }}
            >
              <img
                src="https://alexfish-static.s3.eu-north-1.amazonaws.com/salads.svg"
                alt="Салати"
              />
              <p className="category-title">{t("Салати")}</p>
            </div>
            <div
              className="food-category"
              onClick={() => {
                navigate("/menu/category/24");
                setActive(24);
                localStorage.setItem("activeMenu", 24);
              }}
            >
              <img
                src="https://alexfish-static.s3.eu-north-1.amazonaws.com/starters.svg"
                alt="Стартери"
              />
              <p className="category-title">{t("Стартери")}</p>
            </div>
            <div
              className="food-category"
              onClick={() => {
                navigate("/menu/category/12");
                setActive(12);
                localStorage.setItem("activeMenu", 12);
              }}
            >
              <img
                src="https://alexfish-static.s3.eu-north-1.amazonaws.com/sushi.svg"
                alt="Суши"
              />
              <p className="category-title">{t("Суши")}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
